import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import PropTypes from "prop-types";
import RenderFields from "./RenderFields";

const RenderSAColumnConfigTable = ({
  section,
  sectionIndex,
  formData,
  handleFieldChange,
  formErrors,
  viewOnly,
  actionClicked,
  opsCertiView,
  handleSAColumnConfigSave,
  configCertStatusRPCID,
}) => {
  return (
    <div key={sectionIndex} className="configureTableRow row my-2">
      <Card className="Scrollable configureTableCard">
        <CardBody>
          <CardTitle tag="h5" className="section_heading">
            {section.title}
          </CardTitle>
          <div className="row">
            {section.fields.map((field, fieldIndex) => (
              <div key={fieldIndex} className={`col-md-${field.width || 4} mb-2`}>
                <RenderFields
                  field={field}
                  sectionIndex={1}
                  fieldIndex={fieldIndex}
                  formData={formData}
                  handleFieldChange={handleFieldChange}
                  formErrors={formErrors}
                  viewOnly={viewOnly || opsCertiView === "view"}
                  actionClicked={actionClicked}
                  isNoLabel={true}
                />
              </div>
            ))}
          </div>
          {opsCertiView !== "view" && (
            <div className="operationCertificateBtns align-end">
              {configCertStatusRPCID || formData[0]?.rpc_id ? (
                <button
                  type="button"
                  className="saveBtn View_Details"
                  onClick={() => handleSAColumnConfigSave("Edit")}
                >
                  Update
                </button>
              ) : (
                <button
                  type="button"
                  className="saveBtn View_Details"
                  onClick={() => handleSAColumnConfigSave("Save")}
                >
                  Save
                </button>
              )}
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

RenderSAColumnConfigTable.propTypes = {
  section: PropTypes.object,
  sectionIndex: PropTypes.number,
  formData: PropTypes.object,
  handleFieldChange: PropTypes.func,
  formErrors: PropTypes.object,
  viewOnly: PropTypes.bool,
  actionClicked: PropTypes.bool,
  opsCertiView: PropTypes.string,
  handleSAColumnConfigSave: PropTypes.func,
  configCertStatusRPCID: PropTypes.any,
};

export default RenderSAColumnConfigTable;
